import Head from 'next/head'
import Image from 'next/image'
import styles from '../styles/Home.module.css'
import Homes from '../components/home/Homes'

export default function Home() {
  return (
    <div className={styles.container}>
      <Head>
        <title>School of Our Divine Infinite Being</title>
        <meta name="description" content="Generated by create next app" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Homes/>
    </div>
  )
}
